


  function attachShadowStyle(selector) {
  const interval = setInterval(() => {
    const host = document.querySelector(selector);
    if (host && host.shadowRoot) {
      // Gắn CSS vào shadow root
      const style = document.createElement("style");
      style.textContent = `
        .qo-page-no-access-title {
    font-size : 25px ; 
    }
      `;
      host.shadowRoot.appendChild(style);

      console.log("✅ Shadow root found & style attached!");
      clearInterval(interval);
    }
  }, 200); // check mỗi 200ms
    setTimeout(() => {
     clearInterval(interval);
  }, 5000);
}

// Gọi hàm
attachShadowStyle("div:has(bss-qo)");


  